const colors = {
  primary: '#F6C148',
  secondary: '#71A8BE',
  darkSecondary: '#4A7080',
  tertiary: '#76C9F2',
  accent: '#b9e3f3',
  white: '#FFF',
  toupe: '#FBFBFB',
  description: '#707070',
  black: '#000000DE',
  reallyDarkGrey: '#9B9B9B',
  darkerGrey: '#646363',
  darkGrey: '#555555',
  duskyGrey: '#6E6E6E',
  standardGrey: '#EFEFF4',
  lightGrey: '#F4F4F4',
  lighterGrey: '#FAFAFA',
  veryLightGrey: '#00000033',
  red: '#C4104C',
  inactive: '#9e9e9e',
  dividerGrey: '#E1DFDD',
  warning: '#FF0000',
  success: '#5BC236',
  origin: '#E87722',
  main: '#991B29',
};

export default colors;
